import {
    GridToolbarContainer,
    GridToolbarExport,
    GridToolbarQuickFilter
} from '@mui/x-data-grid';


const DataTableToolbarWithExportAndSearch = ()=> (
    <GridToolbarContainer>
        <GridToolbarExport printOptions={{ disableToolbarButton: true }} />
        <GridToolbarQuickFilter style={{ marginLeft: 'auto', marginRight: 0 }} />
    </GridToolbarContainer>
);

export default DataTableToolbarWithExportAndSearch;
